import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const ExprimeCharteCard = () => {
  return (
    <Card className="bg-gradient-to-br from-[#39CCFF]/20 to-[#39CCFF]/10 border-[#39CCFF]/30">
      <CardHeader>
        <CardTitle className="text-2xl md:text-3xl font-bold text-[#00123A]">
          L'Académie d'Aix-Marseille lance le concours « Exprime la Charte » !
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-base md:text-lg text-foreground/90 leading-relaxed">
          Le concours « Exprime la Charte ! » invite les élèves à s'approprier les valeurs républicaines 
          en réalisant une production collective (texte, affiche, vidéo, slam, dessin...) autour de la 
          Charte des Droits et Devoirs du Citoyen français.
        </p>
        <p className="text-base md:text-lg text-foreground/90 leading-relaxed">
          L'association a proposé à l'Académie d'Aix-Marseille l'organisation d'un concours, intitulé 
          « Exprime la Charte ! », qui a pour objectifs de permettre aux jeunes d'exprimer cette charte 
          à travers leurs propres codes : en mots, en images et/ou en musique. Il s'agit d'un travail d'équipe,
          où les participants expriment tout ou partie de la Charte en lien avec les valeurs fondamentales 
          de la République : Liberté, Égalité, Fraternité, Laïcité.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 pt-2">
          <Link 
            to="/blog#post9" 
            className="inline-flex items-center justify-center bg-[#00123A] hover:bg-[#00123A]/90 text-white px-6 py-3 rounded-lg font-medium transition-colors"
          >
            Plus d'info sur le concours et le projet pédagogique
            <ArrowRight className="ml-2" size={20} />
          </Link>
        </div>
      </CardContent>
    </Card>
  );
};
